import { render, staticRenderFns } from "./BFBottomBanner.vue?vue&type=template&id=4999fc7c&"
import script from "./BFBottomBanner.vue?vue&type=script&lang=js&"
export * from "./BFBottomBanner.vue?vue&type=script&lang=js&"
import style0 from "./BFBottomBanner.vue?vue&type=style&index=0&module=true&lang=less&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./BFBottomBanner.vue?vue&type=style&index=0&module=true&lang=less&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./BFBottomBanner.vue?vue&type=style&index=0&module=true&lang=less&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("4999fc7c")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4999fc7c')) {
      api.createRecord('4999fc7c', component.options)
    } else {
      api.reload('4999fc7c', component.options)
    }
    module.hot.accept("./BFBottomBanner.vue?vue&type=template&id=4999fc7c&", function () {
      api.rerender('4999fc7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/paymentPlans/components/blackFriday2025/BFBottomBanner.vue"
export default component.exports